export const HOVERCARD_TARGET_SELECTOR = '[data-hovercard-url]'

// The amount of extra time given to move into the content
export const CLOSE_DELAY = 100

// The minimum time before opening the hovercard via mouseover
export const OPEN_DELAY = 500

// Minimum time before preloading the hovercard on mouseover
export const PRELOAD_DELAY = 200
